const miscRoutes = [
    {
        path: '/portfolio/:name', // портфолио пользователя
        component: () => import('pages/portfolio/Portfolio.vue'),
    },

    // заявки
    {
        path: '/reg',
        component: () => import('layouts/RegLayout'),
        children: [
            { path: '', component: () => import('pages/reg/RegRootPage.vue') },
            { path: 'adult', component: () => import('pages/reg/RegAdult.vue') },
        ],
    },
    { path: '/gu', component: () => import('pages/GU') },
    {
        path: '/:catchAll(.*)*',
        component: () => import('pages/Error404.vue'),
    },
    {
        path: '/404',
        component: () => import('pages/Error404.vue'),
    },
    {
        path: '/server-works',
        component: () => import('pages/Works.vue'),
    },
    {
        path: '/code-hub',
        component: () => import('pages/CodeHub.vue'),
    },
    {
        path: '/leader',
        component: () => import('pages/Leader.vue'),
    },
];

export default miscRoutes;
